const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0x5eba2e191e1650043f50e9454a87f1998317b1a2',
  busdAddress: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
  lpAddress: '0xEBedF67E37F0C7F2b9018EdD04cb3460d1b2C16B'
}

export default priceContracts